import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createContactClient({ commit }, data) {
      try {
        return await api.post(
          `/clients/${data.clienteId}/contacts`,
          data.contact,
        )
      } catch (error) {
        throw error
      }
    },

    async getContactsClient({ commit }, clienteId) {
      try {
        const response = await api.get(`/clients/${clienteId}/contacts`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getContactClient({ commit }, { clienteId, contatoId }) {
      try {
        const response = await api.get(
          `/clients/${clienteId}/contacts/${contatoId}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateContactClient({ commit }, data) {
      try {
        return await api.put(
          `/clients/${data.clienteId}/contacts/${data.contatoId}`,
          data.contact,
        )
      } catch (error) {
        throw error
      }
    },

    async getContactsToImportClient({ commit }, clienteId) {
      try {
        const response = await api.get(`/clients/${clienteId}/contacts/import`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async importContactsClient({ commit }, { clienteId, contatos }) {
      try {
        return await api.post(`/clients/${clienteId}/contacts/import`, {
          contatos,
        })
      } catch (error) {
        throw error
      }
    },

    async deleteContactClient({ commit }, { clienteId, contatoId }) {
      try {
        return await api.delete(`/clients/${clienteId}/contacts/${contatoId}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
